<template>
  <small class="reads-indicator">
    <FriedTooltip
      :delay="{ show: 300, hide: 100 }"
      :distance="8"
      :placement="TooltipPlacement.TopEnd"
    >
      {{ readEvents.length }}
      <template #popper>
        <p v-for="(readEvent, index) in readEvents" :key="index">
          {{ readEvent }}
        </p>
      </template>
    </FriedTooltip>
  </small>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { Placement as TooltipPlacement } from '@getaccept/fried-tofu';

export default defineComponent({
  props: {
    readEvents: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  setup() {
    return { TooltipPlacement };
  },
});
</script>
<style lang="scss" scoped>
.reads-indicator {
  border-radius: 20px;
  height: 20px;
  width: 20px;
  background-color: var(--gray-89);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-dark);
  font-weight: 700;
  margin-top: var(--spacing-50);
  align-self: flex-end;
}
</style>
